module.exports = __webpack_public_path__ + "static/media/withdrawals.b7c5595f.svg";